import {z}from'zod';const e=z.object({token:z.string()});export{e as LoginRequestSchema};